
/**
 * Parametros requeridos
 * action: 0: ELIMINAR | 1: NUEVO | 2: EDITAR | 3: VER
 * dataProfile: object
 * dialogProfile: true || false
 */

import { defineComponent, ref, inject, reactive, provide } from 'vue'
//compoenents
import swPerson from "../steps/swPerson.vue"
import PhotoManager from "@/views/persons/photo/PhotoManager.vue";
import sFiles from "@/components/wizard/steps/sFiles.vue"
import Anotations from "@/components/widgets/mixed/Anotations.vue"
import LineTime from "@/components/widgets/mixed/LineTime.vue"
import { actions } from "@/core/data/shared";
import { useI18n } from "vue-i18n/index";
import GlobalService from '@/core/services/GlobalService';
export default defineComponent({
    props: {
        action: {
            type: null,
            required: true,
            default: 0
        }, 
        status: {
            type: null,
            required: true,
            default: []
        },
        idinstitution: {
            type: null,
            required: false,
            default: null
        }
    },
    components: { swPerson, PhotoManager, sFiles, Anotations, LineTime },
    emits: ['onResponseMdPerfil'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const gblAccount = inject<any>('gblAccount');
        const ta = ref(process.env.VUE_APP_TA);
        const listActions = actions;
        const listTypeFile = ref<any[]>([]);
        const action = ref<number>(0);
        const dataProfile = inject<any>('dataProfile');
        const dialogProfile = inject<any>('dialogProfile');
        
        const altura = screen.height - 200;
        const activeTab = ref('tabX');
        provide("listTypeFile", listTypeFile)
        const options = reactive([
            {
                label: t('personalData'),
                value: 'tab1',
                icon: 'bi bi-person-vcard',
                disabled: false
            },
            {
                label: t('photography'),
                value: 'tab2',
                icon: 'bi bi-image',
                disabled: true
            },
            {
                label: t('documentation'),
                value: 'tab3',
                icon: 'bi bi-folder-fill',
                disabled: true
            },
            {
                label: t('remarks'),
                value: 'tab4',
                icon: 'bi bi-info-circle-fill',
                disabled: true
            }
        ])

        const OptionsActivate = (value: boolean) => {
            options.forEach(item => item.disabled = value);
        }

        const onOpen = () => {
            action.value = props.action;
            let _disabled = (action.value == 1) ? true : false
            OptionsActivate(_disabled);
            getListTypeFile();
        }

        const onOpened = () => {
            activeTab.value = 'tab1'
        }

        const onClosed = () => {
            activeTab.value = 'tabX'
            emit("onResponseMdPerfil", "")
        }

        //metodo del forumlario 1: persona
        const onResponse = (data) => {
            if (data.status == 'success') {
                dataProfile.value = data.payroll
                action.value = 2;
                OptionsActivate(false);
                //dataProfile.value.payroll = data.payroll;
                //dataProfile.value.message = data.message;
                //dataProfile.value.persona = data.persona;
            }
        };

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await GlobalService.get('api/file/payroll', 'type')
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        return {
            t,
            ta,
            action,
            gblAccount,
            dialogProfile,
            dataProfile,
            listActions,
            altura,
            activeTab,
            options,
            //methods
            onOpen,
            onOpened,
            onClosed,
            onResponse
        }
    },
})
